import { Text } from "../../Components/atoms/Typography/Text/Text";
import { ActionButton } from "../../Components/molecules/ActionButton/ActionButton";

export const getColumns = (t, clickHandler) => {
  const getUserName = (row) => {
    const value = row?.UserName || row?.userName;
    return typeof value === "string" && value.trim() ? value.trim() : "-";
  };

  const formatPhoneNumber = (phoneNumber) => {
    // Format the phone number
    const formattedNumber = phoneNumber.replace(
      /(\d{2})(\d{4})(\d{4})/,
      "$1 $2 $3",
    );

    return formattedNumber;
  };
  let columndata = [
    {
      fieldtext: t("common:table-field.user-id"),
      field: "docId",
      width: "180",
      textAlign: "Left",
    },
    {
      fieldtext: t("common:table-field.name"),
      field: "fullName",
      width: "180",
      textAlign: "Left",
    },
    {
      fieldtext: t("glossary:doctor-details.user-name"),
      field: "userName",
      width: "180",
      textAlign: "Left",
      template: (props) => {
        return <span>{getUserName(props)}</span>;
      },
    },
    {
      fieldtext: t("common:table-field.prof-license-no"),
      field: "professionalLiceneseNumber",
      width: "180",
      textAlign: "Left",
      template: (props) => {
        return (
          <span
            style={{
              color: !props.verifyDoctor && "red",
            }}
          >
            {props.professionalLiceneseNumber}
          </span>
        );
      },
    },
    {
      fieldtext: t("common:table-field.specialty"),
      field: "SpecializationDesc",
      width: "180",
      textAlign: "Left",
      template: (props) => {
        return (
          <span>
           {Array.isArray(props?.speciality) && props?.speciality?.length > 0
            ? props.speciality.length > 2
              ? props.speciality.slice(0, 2).map((s) => s.Description).join(", ") + ", ..."
              : props.speciality.map((s) => s.Description).join(", ")
            : ""}
          </span>
        );
      },
    },
    {
      fieldtext: t("common:table-field.mobile-no"),
      field: "phoneNumber",
      width: "180",
      textAlign: "Left",
      enableGroupByFormat: true,
      template: (props) => {
        return (
          <span>{`${props.phoneNumberDialCode} ${formatPhoneNumber(
            props.phoneNumber,
          )}`}</span>
        );
      },
    },
    {
      fieldtext: "Featured status",
      field: "isFeatured",
      width: "180",
      textAlign: "Left",
      enableGroupByFormat: true,
      template: (props) => {
        return (
          <span>
            {props.isFeatured ? "Featured" : "Unfeatured"}
          </span>
        );
      },
    },
    {
      fieldtext: t("common:table-field.created-date"),
      field: "createDate",
      width: "180",
      textAlign: "Left",
      enableGroupByFormat: true,
    },    
    {
      fieldtext: t("common:table-field.actions"),
      field: "actions",
      width: "88px",
      textAlign: "Left",
      allowSorting: false,
      headerTextAlign: "Left",
      template: (props) => {
        return (
          <ActionButton
            clickHandler={(e) => clickHandler(e, props)}
            Options={[
              {
                id: 1,
                element: (
                  <Text
                    text={t("common:action.view")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 2,
                isShow: !props?.isPasswordReset,
                element: (
                  <Text
                    text={t("glossary:user.action.reset-password")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 3,
                isShow: props.isBlocked ? false : undefined,
                element: (
                  <Text
                    text={
                      props?.isActive
                        ? t("glossary:user.action.inactivate-account")
                        : t("glossary:user.action.activate-account")
                    }
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 4,
                element: (
                  <Text
                    text={
                      props.isBlocked
                        ? t("glossary:doctor.un-block.title")
                        : t("glossary:doctor.block.title")
                    }
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 5,
                element: (
                  <Text
                    text={t("glossary:auth.reset-otp-count.reset-otp-count")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 6,
                element: (
                  <Text
                    text={
                      props.isFeatured
                        ? "Unfeatured"
                        : "Mark as featured"
                    }
                    color={"blue.primaryBlue"}
                  />
                ),
              },
            ]}
          />
        );
      },
    },
  ];
  return columndata;
};
